<template>
  <div class="layout">
    <header class="top">
      <div class="container row">
        <router-link to="/" class="brand">ProduPneu</router-link>

        <nav class="nav">
          <router-link to="/products">Products</router-link>
          <router-link to="/account">Account</router-link>
          <router-link to="/my-orders">Orders</router-link>
          <button class="btn" @click="logout">Logout</button>
        </nav>
      </div>
    </header>

    <main class="container content">
      <slot />
    </main>
  </div>
</template>

<script>
export default {
  name: "ClientLayout",
  methods: {
    async logout() {
      try {
        await this.$store.dispatch("auth/logout");
      } finally {
        this.$router.push({ name: "home" });
      }
    },
  },
};
</script>

<style scoped>
.top { background: #fff; border-bottom: 1px solid #eee; }
.row { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.brand { font-weight: 700; text-decoration: none; color: #111; }
.nav { display: flex; align-items: center; gap: 12px; }
.nav a { text-decoration: none; color: #111; }
.btn { border: 1px solid #ddd; background: #fff; padding: 6px 10px; cursor: pointer; border-radius: 6px; }
.content { padding-top: 18px; }
</style>
